<template>
  <div class="link-coverage-bar" :title="tooltipText">
    <div class="bar-section unlinked" :style="{ width: unlinkedPercent + '%' }"></div>
    <div class="bar-section linked" :style="{ width: linkedPercent + '%' }"></div>
  </div>
</template>

<script setup lang="ts">
  import { useArtifactTypeCoverage } from '@/composables/useArtifactTypeCoverage'

  const props = defineProps({
    artifactTypeId: { type: Number, required: true },
  })

  const { unlinkedPercent, linkedPercent, tooltipText } = useArtifactTypeCoverage(
    () => props.artifactTypeId,
  )
</script>

<style scoped lang="scss">
  .link-coverage-bar {
    display: flex;
    width: 100%;
    height: 8px;
    border-radius: 4px;
    overflow: hidden;
    background-color: #e0e0e0;
  }

  .bar-section {
    height: 100%;
    transition: width 0.3s ease;
  }

  .unlinked {
    background-color: #e57373; // Red - no links
  }

  .linked {
    background-color: #81c784; // Green - linked
  }
</style>
